import { Typography, Grid, Tooltip, IconButton, Button, Slider } from "@material-ui/core";
import LevelManager from "../../levels";
import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import CostumeDisplay from "../components/CostumeDisplay";
import Sprite, {CostumeEntry} from '../../sprite';
import { Restore } from "../../utils/restore";
import { translate } from "../../i18n/i18n";
import LibraryCostumeModal from "../LibraryCostumeModal";
import AddIcon from '@material-ui/icons/Add';
import { AppRoot, notifyUser } from "../../app";
import WorkspaceManager from "src/workspace";
import { SpriteEditInfoField } from "../SpriteEditor/components/SpriteEditorInfoField";
import Switch from "../components/Switch";


const titleClass = {
    fontSize: '1.6rem',
    padding: '1rem 0rem',
    fontFamily: 'ABeeZee',
    color: 'white',
};

const subtitleClass = {
    fontSize: '1.2rem',
    padding: '1rem 0rem',
    fontFamily: 'ABeeZee',
    color: 'white',
};

const buttonTextClass = {
    fontSize: '1.2rem',
    padding: '1rem 0rem',
    fontFamily: 'ABeeZee',
    color: '#37373',
};

interface SpriteMenuProps extends WithTranslation {
    sprite: Sprite | null;
    readonly onSpriteSelected: (sprite: Sprite | null) => void;
    readonly deleteSprite: (sprite: Sprite) => void;
    readonly setStartConfig: (sprite: Sprite) => void;
}

interface SpriteMenuState {
    isInitialWs: boolean;
    dragging: boolean;
}

class SpriteMenu extends React.Component<SpriteMenuProps, SpriteMenuState> {   
    
    constructor(props: SpriteMenuProps) {
        super(props);
        this.state = {
            dragging: false,
            isInitialWs: false
        };
    }

    getIsInitialWs = () => {
        if ((window as any).workspaceManager && (window as any).workspaceManager.activeWorkspace) {
            return (window as any).workspaceManager.initialWorkspaceID === (window as any).workspaceManager.activeWorkspace!.id;
        }
        return false;
    }

    /**
     * Delete a costume from the sprite.
     * @param {CostumeEntry} costume
     * 
     */
    handleDeleteCostume = (costume: CostumeEntry) => {
        //Intentionally reusing the same ref for the new state.
        if (this.props.sprite) {
            this.props.sprite.removeCostume(costume);
            this.props.onSpriteSelected(this.props.sprite);
            Restore.createRestorePoint(translate('RestoreMessages.costume.deleted') + costume.name);
            (window as any).renderUtils.generateColorPalette();
        }
    };

    /**
     * Set the sprites costume.
     * @param {CostumeEntry} costume
     */
    handleSetCurrentCostume = (costume: CostumeEntry) => {
        const sprite = this.props.sprite;
        if (sprite && sprite.costumes.indexOf(costume) > -1) {
            sprite.costumeId = costume.id;
            sprite.updateCostume();
            (window as any).renderUtils.generateColorPalette();
        }
    };

    /**
     * Returns the number of the current sprites costumes
     */
    getCostumesLength = () => {
        if (this.props.sprite) {
            return this.props.sprite.costumes.length;
        }
        return 0;
    };

    handleToggleSystemCostume = (costume: CostumeEntry) => {
        costume.isSystemCostume = !costume.isSystemCostume;
    };

    deleteCurrentSprite = () => {
        if (this.props.sprite) {
            this.props.deleteSprite(this.props.sprite);
        }
    };
    
    setStartConfigCurrentSprite = () => {
        if (this.props.sprite) {
            const { t, sprite } = this.props;
            this.props.setStartConfig(sprite);
            notifyUser(t('SpriteEditor.NOTIFY_START_POSITION_SET'), { variant: 'success' });
        }
    };

    /**
     * Updates the "z-index" of the sprite layer
     */
    handleSpriteLayerChange = (e: any, index: number | number[]) => {
        if (this.props.sprite && typeof index === 'number') {
            this.props.sprite.layer = index;
        }
    };

    // keep track of latest dragging update
    private latest: any = {
        x: 0,
        y: 0,
        dragging: false,
        update: Date.now(),
    };
    updateDragging = (force: boolean = false) => {
        // is last update more than 100ms ago?
        if (Date.now() - this.latest.update < 100 && !force) {
            return;
        }
        // check if not playing, sprite is set, and there are any changes
        if ((!AppRoot.INSTANCE.state.isPlaying && this.props.sprite
            && (
                this.props.sprite.x !== this.latest.x
                || this.props.sprite.y !== this.latest.y
                || this.props.sprite.dragging !== this.latest.dragging
            ))
            || (force && this.props.sprite)
        ) {
            // update interface
            this.setState({ dragging: this.props.sprite.dragging });
            // update latest status
            this.latest.x = this.props.sprite.x;
            this.latest.y = this.props.sprite.y;
            this.latest.dragging = this.props.sprite.dragging;
            this.latest.update = Date.now();
        }
    };
    

    render() {
        const { t, sprite } = this.props;
        const { isInitialWs } = this.state;

        if (this.getIsInitialWs() !== isInitialWs) {
            this.setState({ isInitialWs: this.getIsInitialWs() });
        }

        if (!sprite) {
            return null;
        }
    
        let onlyCostume = sprite.costumes.length <= 1;
        let isBackground: boolean = sprite.isStaticBackground;
        let positionNotEditable = AppRoot.INSTANCE.state.isPlaying || this.state.dragging;
        
        return (        
            <div style={{padding: "0px 8px", height: '100%', }}>
                <div className="col" style={{
                    backgroundColor: '#1F662F',
                    border: '4px solid #093914',
                    borderRadius: "8px",
                    padding: '1rem',
                    height: 'calc(100% - 44px)',
                    display: 'flex', 
                    gap: '8px', 
                    flexDirection: 'column',
                    overflow: 'auto', 
                    whiteSpace: 'nowrap', 
                    overflowX: 'hidden', 
                    overflowY: 'auto'
                }}>
                    <div className="row">
                        <Typography variant="h6" style={titleClass}>
                            {t('SpriteEditor.Settings')}
                        </Typography>
                    </div>
                        <div className="costume" style={{ background: '#438652', borderRadius: '0.5rem', padding: '0.5rem', }}>
                            <Typography variant="h6" style={subtitleClass}>
                                {t('SpriteEditor.CostumesTabLabel')}
                            </Typography>
                            <Grid container={true} spacing={2}>
                                {
                                    sprite.costumes.map((costume, index) => {
                                        return (
                                            <Grid key={index} item={true} xs={6} md={6} lg={4} xl={4}>
                                                <CostumeDisplay
                                                    isActive={sprite.costumeId === costume.id}
                                                    index={index}
                                                    onCostumeClicked={this.handleSetCurrentCostume}
                                                    deleteCostume={this.getCostumesLength() > 1 ? this.handleDeleteCostume : undefined}
                                                    costume={costume}
                                                    readonly={costume.isSystemCostume}
                                                    setIsSystemState={LevelManager.isBuildMode() ? this.handleToggleSystemCostume : undefined}
                                                    onlyCostume={onlyCostume}
                                                />
                                            </Grid>);
                                    })

                                }
                                <Grid style={{ display: "flex", justifyContent: " center", alignItems: "center" }} item={true} xs={6} md={6} lg={4} xl={4}>
                                    {
                                    (LevelManager.isBuildMode() || sprite.allowCostumeEdit) &&
                                        <Tooltip title={t('SpriteEditor.AddCostumeTooltip') as string} disableFocusListener>
                                        <LibraryCostumeModal sprite={sprite}
                                            trigger={
                                                <IconButton style={{ backgroundColor: '#1A652B', border: '2px solid rgb(22, 61, 31)', cursor: 'pointer', width: "60px", height: "60px" }}  >
                                                    <AddIcon style={{ color: 'white', width: "40px", height: "40px" }} />
                                                </IconButton>}
                                            parent={this} />
                                        </Tooltip>
                                    }
                                </Grid>
                            </Grid>
                        </div>
                        {
                            (LevelManager.isBuildMode()) && 
                            <div style={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
                                { !isBackground &&
                                    <div style={{ background: '#438652', borderRadius: '0.5rem', padding: '0.5rem' }}>
                                    <Typography style={subtitleClass}>
                                        {t('SpriteEditor.Actions')} 
                                    </Typography>
                                    <div style={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
                                        {
                                            sprite.programmable &&
                                            <Button
                                                style={{ backgroundColor: '#FFAF8D', border: '3px solid rgb(22, 45, 61)', cursor: 'pointer', width: "100%", height: "42px", borderRadius: "8px", textTransform: 'none' }}
                                                onClick={(t) => {
                                                    const workspaceManager = (window as any).workspaceManager as WorkspaceManager;
                                                    workspaceManager.initialWorkspaceID = workspaceManager.activeWorkspace!.id;
                                                    this.setState({ isInitialWs: true });
                                                }}
                                                disabled={isInitialWs}
                                            >
                                                <Typography style={buttonTextClass}>{t('SpriteEditor.Graphics.InitialWS.btnSetInitial')}</Typography>
                                            </Button>
                                        }
                                        <Button
                                            style={{ backgroundColor: '#CAE2FC', border: '3px solid rgb(22, 45, 61)', cursor: 'pointer', width: "100%", height: "42px", borderRadius: "8px", textTransform: 'none' }}
                                            onClick={() => this.setStartConfigCurrentSprite()}
                                        >
                                            <Typography style={buttonTextClass}>{t('SpriteEditor.TooltipSetStartConfig')}</Typography>
                                        </Button>
                                        <Button
                                            style={{ backgroundColor: '#B6F088', border: '3px solid rgb(22, 61, 31)', cursor: 'pointer', width: "100%", height: "42px",borderRadius: "8px", textTransform: 'none' }}
                                            onClick={() => AppRoot.INSTANCE.duplicateSprite()}
                                        >
                                            <Typography style={buttonTextClass}>{t('MENU.DUPLICATE_SPRITE')}</Typography>
                                        </Button>
                                        <Button
                                            style={{ backgroundColor: '#E97183', border: '3px solid rgb(61, 25, 22)', cursor: 'pointer', width: "100%", height: "42px", borderRadius: "8px", textTransform: 'none' }}
                                            onClick={() => this.deleteCurrentSprite()}
                                        >
                                            <Typography style={buttonTextClass}>{t('SpriteEditor.TooltipDeleteSprite')}</Typography>
                                        </Button>
                                    </div>
                                </div>}
                                {(LevelManager.isBuildMode() && !isBackground) && 
                                <div style={{ background: '#438652', borderRadius: '0.5rem', padding: '0.5rem' }}>
                                    <Typography style={subtitleClass}>
                                        {t('SpriteEditor.GraphicsTabLabel')} 
                                    </Typography>
                                    <div>
                                        <div style={{ display: 'flex', gap: '8px', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <Typography style={{ fontSize: '1rem', padding: '1rem 0rem', fontFamily: 'ABeeZee', color: 'white' }}>
                                                {t('SpriteEditor.Graphics.Scale.title')} 
                                            </Typography>	
                                            <SpriteEditInfoField sprite={sprite} spriteInfo={"scale"}
                                                label={t('SpriteEditor.Graphics.Scale.label')} width={50}
                                                disabled={positionNotEditable} updateDragging={this.updateDragging}
                                                >
                                            </SpriteEditInfoField>
                                            {
                                                (sprite.scale > 1.2 || sprite.scale < 0.8) &&
                                                <Typography style={{ fontSize: "0.75rem", fontStyle: "italic", fontFamily: 'ABeeZee', color: 'white'  }}>
                                                    {t('SpriteEditor.Graphics.Scale.warning')}
                                                </Typography>
                                            }
                                        </div>
                                        <div style={{ display: 'flex', gap: '8px', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                                            
                                            <div key={sprite.layer}>
                                                <Slider
                                                    valueLabelDisplay="auto"
                                                    defaultValue={sprite.layer}
                                                    onChange={this.handleSpriteLayerChange}
                                                    min={1}
                                                    max={(window as any).world.container.children.length - 2}
                                                    step={2}
                                                    marks
                                                    style={{ width: '260px' }}
                                                    disabled={positionNotEditable}
                                                    />
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', gap: '8px', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                                            <Button
                                                style={{ backgroundColor: '#FFAF8D', border: '3px solid rgb(22, 45, 61)', cursor: 'pointer', width: "100%", height: "42px", borderRadius: "8px", textTransform: 'none' }}
                                                onClick={() => {
                                                    if (sprite) {
                                                        sprite.mirror("X");
                                                    }
                                                }}
                                                >
                                                <Typography style={buttonTextClass}>{t('SpriteEditor.Graphics.Mirror.btnX-axis')}</Typography>
                                            </Button>
                                            <Button
                                                style={{ backgroundColor: '#CAE2FC', border: '3px solid rgb(22, 45, 61)', cursor: 'pointer', width: "100%", height: "42px", borderRadius: "8px", textTransform: 'none' }}
                                                onClick={() => {
                                                    if (sprite) {
                                                        sprite.mirror("Y");
                                                    }
                                                }}>
                                                <Typography style={buttonTextClass}>{t('SpriteEditor.Graphics.Mirror.btnY-axis')}</Typography>
                                            </Button>
                                        </div>    
                                    </div>
                                </div>
                                }
                                <div style={{ background: '#438652', borderRadius: '0.5rem', padding: '0.5rem' }}>
                                    <Typography style={subtitleClass}>
                                        {t('SpriteEditor.PermissionsTabLabel')} 
                                    </Typography>
                                    <div>
                                        <div style={{ display: 'flex', gap: '8px', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <Typography style={{ fontSize: '1rem', padding: '1rem 0rem', fontFamily: 'ABeeZee', color: 'white' }}>
                                                {t('SpriteEditor.Permissions.Costumes.title')}
                                            </Typography>
                                                <Switch
                                                    onChange={() => {
                                                        if (sprite) {
                                                            sprite.allowCostumeEdit = !sprite.allowCostumeEdit;
                                                            this.props.onSpriteSelected(sprite);
                                                        }
                                                    }}
                                                    checked={sprite.allowCostumeEdit || false}
                                                />
                                        </div>
                                        <div style={{ display: 'flex', gap: '8px', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <Typography style={{ fontSize: '1rem', padding: '1rem 0rem', fontFamily: 'ABeeZee', color: 'white' }}>
                                                {t('SpriteEditor.Permissions.Programmable.title')}
                                            </Typography>
                                                <Switch
                                                    onChange={() => {
                                                        if (sprite) {
                                                            sprite.programmable = !sprite.programmable;
                                                            this.props.onSpriteSelected(sprite);
                                                        }
                                                    }}
                                                    checked={sprite.programmable || false}
                                                />
                                        </div>
                                        <div style={{ display: 'flex', gap: '8px', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <Typography style={{ fontSize: '1rem', padding: '1rem 0rem', fontFamily: 'ABeeZee', color: 'white' }}>
                                                {t('SpriteEditor.Permissions.Draggable.title')}
                                            </Typography>
                                                <Switch
                                                     onChange={() => {
                                                        if (sprite) {
                                                            sprite.draggable = !sprite.draggable;
                                                            this.props.onSpriteSelected(sprite);
                                                        }
                                                    }}
                                                    checked={sprite.draggable || false}
                                                />
                                        </div>
                                        <div style={{ display: 'flex', gap: '8px', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <Typography style={{ fontSize: '1rem', padding: '1rem 0rem', fontFamily: 'ABeeZee', color: 'white' }}>
                                                {t('SpriteEditor.Permissions.Deletable.title')}
                                            </Typography>
                                                <Switch
                                                     onChange={() => {
                                                        if (sprite) {
                                                            sprite.deletable = !sprite.deletable;
                                                            this.props.onSpriteSelected(sprite);
                                                        }
                                                    }}
                                                    checked={sprite.deletable || false}
                                                />
                                        </div>
                                        <div style={{ display: 'flex', gap: '8px', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <Typography style={{ fontSize: '1rem', padding: '1rem 0rem', fontFamily: 'ABeeZee', color: 'white' }}>
                                                {t('SpriteEditor.Permissions.IsInput.title')}
                                            </Typography>
                                                <Switch
                                                    onChange={() => {
                                                        if (sprite) {
                                                            sprite.isInput = !sprite.isInput;
                                                            this.props.onSpriteSelected(sprite);
                                                        }
                                                    }}
                                                    checked={sprite.isInput || false}
                                                />
                                        </div>
                                        <div style={{ display: 'flex', gap: '8px', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <Typography style={{ fontSize: '1rem', padding: '1rem 0rem', fontFamily: 'ABeeZee', color: 'white' }}>
                                                {t('SpriteEditor.Permissions.MobileOnly.title')}
                                            </Typography>
                                                <Switch
                                                    onChange={() => {
                                                        if (sprite) {
                                                            sprite.mobileOnly = !sprite.mobileOnly;
                                                            this.props.onSpriteSelected(sprite);
                                                        }
                                                    }}
                                                    checked={sprite.mobileOnly || false}
                                                />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        { sprite.deletable && !LevelManager.isBuildMode() &&
                            <div style={{ background: '#438652', borderRadius: '0.5rem', padding: '0.5rem' }}>
                                <Typography style={subtitleClass}>
                                    {t('SpriteEditor.Actions')} 
                                </Typography>
                                <div style={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
                                    <Button
                                    style={{ backgroundColor: '#E97183', border: '3px solid rgb(61, 25, 22)', cursor: 'pointer', width: "100%", height: "42px", borderRadius: "8px", textTransform: 'none' }}
                                    onClick={() => this.deleteCurrentSprite()}>
                                        <Typography style={buttonTextClass}>{t('SpriteEditor.TooltipDeleteSprite')}</Typography>
                                    </Button>
                                </div>
                         </div>
                        }
                </div>
            </div>
        );
    }
}

export default withTranslation()(SpriteMenu);